import React, { RefObject } from "react";

type Props = {
  editingName: boolean;
  visibleName: string;
  draftName: string;
  nameContainerRef: RefObject<HTMLDivElement>;
  onDraftNameChange: (value: string) => void;
  onStartEditing: () => void;
  onSave: () => void;
  onCancel?: () => void;
  variant?: "center" | "menu";
};

const EditableVisibleName: React.FC<Props> = ({
  editingName,
  visibleName,
  draftName,
  nameContainerRef,
  onDraftNameChange,
  onStartEditing,
  onSave,
  onCancel,
  variant = "center",
}) => {
  const showOptional = !visibleName || visibleName === "No Name";
  const isMenu = variant === "menu";

  if (isMenu) {
    return (
      <div className="name-container name-container-menu" ref={nameContainerRef}>
        {editingName ? (
          <div className="menu-name-edit-row">
            <input
              type="text"
              value={draftName}
              onChange={(e) => onDraftNameChange(e.target.value)}
              autoFocus
              className="visible-name-input menu-name-input"
              placeholder="Enter your name"
              onKeyDown={(e) => {
                if (e.key === "Enter") onSave();
                if (e.key === "Escape") onCancel?.();
              }}
            />

            <button className="menu-name-save" onClick={onSave}>
              Save
            </button>

            <button className="menu-name-cancel" onClick={onCancel}>
              Cancel
            </button>
          </div>
        ) : (
          <button className="menu-name-display" onClick={onStartEditing}>
            <div className="menu-name-copy">
              <span className="menu-name-value">{visibleName || "No Name"}</span>

              {showOptional && (
                <span className="menu-name-hint">Tap to enter your name</span>
              )}
            </div>

            <span className="menu-name-edit-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
              </svg>
            </span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="name-container" ref={nameContainerRef}>
      {editingName ? (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            type="text"
            value={draftName}
            onChange={(e) => onDraftNameChange(e.target.value)}
            autoFocus
            className="visible-name-input"
            onKeyDown={(e) => {
              if (e.key === "Enter") onSave();
              if (e.key === "Escape") onCancel?.();
            }}
          />

          <button
            onClick={onSave}
            style={{
              backgroundColor: "#4CAF50",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "28px",
              height: "28px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ✓
          </button>
        </div>
      ) : (
        <div
          style={{
            cursor: "pointer",
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          onClick={onStartEditing}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              lineHeight: 1,
              textAlign: "center",
            }}
          >
            <span style={{ color: "#000", fontWeight: 500 }}>
              {visibleName || "No Name"}
            </span>

            <svg
              style={{ marginLeft: 6, flexShrink: 0 }}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#888"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
            </svg>
          </div>

          {showOptional && (
            <span
              style={{
                marginTop: 4,
                fontSize: 11,
                color: "#999",
                lineHeight: 1.2,
              }}
            >
              optional “Enter your name here”
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default EditableVisibleName;